import './articleSection.scss';
import { TwitterShareButton } from "react-share";
import ArticleEmptyBlockComponent from "./components/ArticleEmptyBlockComponent";
import NumberedComponent from "../../../termsConditions/sections/termsConditionSection/components/NumberedComponent";

const ArticleSection = () => {
	return (
		<div className="articleSection">
			<div className="articleSection__content">
				<div className="articleSection__content_start">
					<h1>Retrodrops: What are they and how can a beginner profit from them?</h1>
				</div>
				<ArticleEmptyBlockComponent height={'32px'} />
				<div className="articleSection__content_banner">
					<div className="articleSection__content_banner_img">
						<img src={require(`../../../brandAssets/sections/bannersSection/banners/RD.webp`)} alt={'NFD Trade Bot XRP'} />
					</div>
					<div className="articleSection__content_banner_info">
						<div className="articleSection__content_banner_info_label">
							<div className="articleSection__content_banner_info_label_dot"></div>
							<span>WEB 3.0</span>
						</div>
						<TwitterShareButton
							url={'https://nfd-corporate-website.netlify.app'}
							title={'NFD'}
							className="articleSection__content_banner_info_button"
						>
							<span>Share on</span>
							<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
								<g clipPath="url(#clip0_2048_15213)">
									<path d="M8.31022 5.925L13.4352 0H12.2207L7.77073 5.14459L4.21653 0H0.117188L5.49183 7.77954L0.117188 13.9928H1.33171L6.03102 8.55995L9.78451 13.9928H13.8839L8.30993 5.925H8.31022ZM6.64677 7.84808L6.10221 7.07341L1.76931 0.909309H3.63474L7.13144 5.88394L7.67601 6.6586L12.2213 13.1249H10.3559L6.64677 7.84837V7.84808Z" fill="#5E41CE" />
								</g>
								<defs>
									<clipPath id="clip0_2048_15213">
										<rect width="14" height="14" fill="white" />
									</clipPath>
								</defs>
							</svg>
						</TwitterShareButton>
					</div>
				</div>

				<ArticleEmptyBlockComponent height={'48px'} />

				<div className="articleSection__content_block _1">
					<h1>What Are Retroactive Airdrops?</h1>
					<ArticleEmptyBlockComponent height={'32px'} />
					<h2>The concept of retroactive rewards</h2>
					<ArticleEmptyBlockComponent height={'16px'} />
					<div className="articleSection__content_block_description">
						<span>
							The idea of retrodrops emerged in the crypto space as a new and effective way to reward users who supported projects during their earliest stages of development - often without expecting any benefit in return.
						</span>

						<span>
							The term "retrodrop" is a combination of two concepts:
						</span>
						<NumberedComponent
						
							list={[
								'Retro - meaning "backward" or "in the past";',
								'Airdrop - a free distribution of cryptocurrency to users.',
							]}
						/>
						<span>
							So, a retrodrop is when a project distributes its tokens after the fact to users who previously used the platform, app, or contributed to the project’s growth without any prior promise of a reward.
						</span>
						<span>
							The key difference between an airdrop and a retrodrop is that an airdrop is usually publicly announced in advance, while a retrodrop is not disclosed beforehand, and users can only speculate whether such a distribution might happen.						</span>
					</div>

				</div>


				<ArticleEmptyBlockComponent height={'32px'} />

				<div className="articleSection__content_block _2">
					<h2>The concept of retroactive rewards</h2>
					<ArticleEmptyBlockComponent height={'16px'} />
					<div className="articleSection__content_block_description">
						<span>
							The crypto industry is filled with fast-growing startups and experimental projects. In many cases, project teams don’t have the budget for large-scale marketing or the ability to attract major venture capital investments. As a result, they need to solve several key tasks, such as:
						</span>

						<NumberedComponent
							boldPrefix={false}
							isGrayList
							list={[
								'Attracting user attention - to spark interest and find early adopters who believe in the project’s vision, use the product, and spread the word organically;',
								'Rewarding those early users after the project achieves certain development milestones or market success.',
							]}
						/>
						<span>From this need, the idea of retroactive airdrops was born.</span>
					</div>
				</div>

				<ArticleEmptyBlockComponent height={'48px'} />

				<div className="articleSection__content_block _4">
					<h1>Where do projects and startups get the funds for retrodrops?</h1>
					<ArticleEmptyBlockComponent height={'16px'} />
					<div className="articleSection__content_block_description">
						<span>
							Imagine waking up one morning, opening your crypto wallet, and suddenly discovering tokens or money you weren’t expecting. It’s not an error or a fairytale - it’s a real phenomenon made possible by retroactive airdrops. But where does this money come from, and why would anyone give it away for free? Let’s break it down.
						</span>
					</div>
				</div>

				<ArticleEmptyBlockComponent height={'32px'} />
				<div className="articleSection__content_block _5">
					<h2>The origin of tokens (funds) for retrodrops</h2>
					<ArticleEmptyBlockComponent height={'16px'} />
					<div className="articleSection__content_block_description">
						<span>
							Crypto projects typically create their own tokens - a form of native currency backed by utility, incentives, or other mechanisms within their ecosystem. These tokens serve various purposes, such as driving growth, facilitating product use, or attracting attention. When launching, most projects generate a large supply of tokens and reserve a portion of them as part of their internal economy (known as “Tokenomics”) to:
						</span>
						<NumberedComponent
							isGrayList
							list={[
								'Reward users;',
								'Attract new investors;',
								'Promote and grow the project.',
							]}
						/>
						<span>These reserved tokens are what form the funding pool for retroactive airdrops.</span>
					</div>
				</div>

				<ArticleEmptyBlockComponent height={'32px'} />

				<div className="articleSection__content_block _5">
					<h2>Why would a project give away money “for free”?</h2>
					<ArticleEmptyBlockComponent height={'16px'} />
					<div className="articleSection__content_block_description">
						<span>
							At first glance, handing out tokens may seem like an overly generous move - something you rarely see in the traditional world. But in reality, it’s a well-calculated strategy. The key reasons a project might organize a retrodrop include:						</span>
						<NumberedComponent
							isList
							list={[
								'1. Boosting visibility and awareness: When people receive unexpected tokens, they often talk about it publicly - creating powerful word-of-mouth marketing;',
								'2. Rewarding early adopters: It’s a way for teams to thank the people who believed in the project when it was still unknown or in its early stages;',
								'3. Building a loyal community: Users who benefit from a retrodrop are more likely to stay engaged and continue supporting the project in the long run.',
							]}
						/>
					</div>
				</div>



				<ArticleEmptyBlockComponent height={'32px'} />
				<div className="articleSection__content_block _6">
					<h2>How can a project benefit from giving away tokens?</h2>
					<ArticleEmptyBlockComponent height={'16px'} />
					<div className="articleSection__content_block_description">
						<span>One of the most common questions is: Why would a project give away money and not lose from it? In truth, this is a long-term investment in growth and success:</span>
						<NumberedComponent
							boldPrefix
							list={[
								'Marketing through virality: Users who receive tokens often share their excitement on social media, attracting attention from new users and investors organically;',
								'Increased token demand: As more people use the project, the demand for its token grows - leading to an increase in its market value. This benefits both the users and the project itself;',
								'Trust and reputation: By rewarding its community, a project shows transparency, fairness, and commitment - which in turn boosts its reputation and helps draw attention from larger players and long-term supporters.',
							]}
						/>
					</div>
				</div>
				<ArticleEmptyBlockComponent height={'48px'} />
				<div className="articleSection__content_block _7">
					<h1>Top 5 most iconic retrodrops in crypto history</h1>
					<ArticleEmptyBlockComponent height={'16px'} />
					<div className="articleSection__content_block_description">
						<span>Imagine using a crypto service without realizing that one day it might completely change your financial situation. Sounds unreal? But that’s exactly what happened to users of several projects thanks to retroactive airdrops. Let’s take a closer look at the most well-known and surprising cases of such unexpected rewards.</span>
					</div>
				</div>


				<ArticleEmptyBlockComponent height={'32px'} />
				<div className="articleSection__content_block _7">
					<h2>Arbitrum:</h2>
					<ArticleEmptyBlockComponent height={'16px'} />
					<div className="articleSection__content_block_description">
						<span>In the spring of 2023, Arbitrum distributed ARB tokens to users who had simply interacted with their network and actively used applications in its ecosystem.</span>
					</div>
				</div>





				<ArticleEmptyBlockComponent height={'24px'} />
				<div className="articleSection__content_block _7">
					<p>Eligibility criteria and retrodrop overview:</p>
					<ArticleEmptyBlockComponent height={'16px'} />
					<div className="articleSection__content_block_description">
						<span>Eligibility was determined using a point-based system based on user activity in the Arbitrum One and Arbitrum Nova networks. Key criteria included:</span>
						<NumberedComponent
							isGrayList
							list={[
								'Bridging assets to Arbitrum One;',
								'Number of months with active transactions;',
								'Total number of transactions and smart contract interactions;',
								'Overall transaction volume;',
								'Activity on Arbitrum Nova.',
							]}
						/>
						<span>Each action awarded a certain number of points. The minimum for eligibility was 3 points, equivalent to 1,250 $ARB tokens. The highest tier - 12+ points, granted 10,250 $ARB.</span>
						<span>A total of 1.162 billion $ARB tokens were allocated to this airdrop - 11.62% of the full 10 billion supply - with 625,143 unique wallets eligible.</span>
					</div>
				</div>



				<ArticleEmptyBlockComponent height={'24px'} />
				<div className="articleSection__content_block _7">
					<p>Sybil filtering and abuse prevention:</p>
					<ArticleEmptyBlockComponent height={'16px'} />
					<div className="articleSection__content_block_description">
						<span>To prevent abuse, Arbitrum implemented anti-Sybil measures:</span>
						<NumberedComponent
							isGrayList
							list={[
								'Reduced points for accounts performing all actions within 48 hours;',
								'Reduced points for wallets with less than 0.005 ETH and only one smart contract interaction;',
								'Full exclusion of wallets flagged as Sybil via the Hop Protocol list;',
								'This retrodrop became a landmark event, highlighting the value of real user activity in growing decentralized ecosystems.',

							]}
						/>
					</div>
				</div>
				<ArticleEmptyBlockComponent height={'32px'} />
				<div className="articleSection__content_block _8">
					<h2>Optimism:</h2>
					<ArticleEmptyBlockComponent height={'16px'} />
					<div className="articleSection__content_block_description">
						<span>In 2022, Optimism - a Layer 2 solution on Ethereum - surprised users by dropping OP tokens to those who had previously tested the network, made transactions, or used popular Ethereum dApps.</span>
					</div>
				</div>
				<ArticleEmptyBlockComponent height={'24px'} />
				<div className="articleSection__content_block _7">
					<p>Eligibility criteria and retrodrop overview:</p>
					<ArticleEmptyBlockComponent height={'16px'} />
					<div className="articleSection__content_block_description">
						<span>To determine eligibility, Optimism implemented a points-based system that evaluated user activity on both Optimism and Ethereum. The main categories included:</span>
						<NumberedComponent
							boldPrefix={false}
							isGrayList
							list={[
								'Optimism Mainnet users: Addresses that had conducted transactions on the Optimism Mainnet;',
								'Repeat Optimism users: Addresses that made transactions during at least four different weeks;',
								'DAO Participants: Users who had either voted in or created proposals within decentralized autonomous organizations (DAOs);',
								'Multisig-Wallet Signers: Addresses that acted as signers on multisig-wallets with recorded activity;',
								'Gitcoin donors: Users who made donations through the Gitcoin platform.'
							]}
						/>
					</div>
				</div>
				<ArticleEmptyBlockComponent height={'24px'} />
				<div className="articleSection__content_block _7">
					<p>Reward breakdown based on eligibility:</p>
					<ArticleEmptyBlockComponent height={'16px'} />
					<div className="articleSection__content_block_description">
						<span>The size of the reward was directly linked to which criteria a user met:</span>
						<NumberedComponent
							boldPrefix={false}
							isGrayList
							list={[
								'Optimism Mainnet Users: received an average of 776,86 $OP tokens;',
								'Repeat users: eeceived an additional 1 692,49 $OP tokens, totaling 2 469,35 $OP;',
								'DAO Participants: eeceived an average of 271,83 $OP tokens;',
								'Multisig-Wallet signers: eeceived an average of 1 190,26 $OP tokens;',
								'Gitcoin donors: Received an average of 555,92 $OP tokens;',
								'Users who left Ethereum due to high gas fees: Received an average of 409,42 $OP tokens.'
							]}
						/>
						<span>Addresses that matched several categories received bonus tokens depending on how many they qualified for. For example: matching 4 categories: - 4 180,54 $OP tokens, matching 5 categories: - 13 330,16 $OP tokens, matching 6 categories: - 27 534,98 $OP tokens.</span>
						<span>A total of 200 million $OP tokens were allocated for this retrodrop - representing 5% of the total OP supply. At the time of the snapshot (which included an exclusion list), 248 699 unique addresses were eligible to claim tokens.</span>
					</div>
				</div>
				<ArticleEmptyBlockComponent height={'24px'} />
				<div className="articleSection__content_block _7">
					<p>Sybil filtering and abuse prevention:</p>
					<ArticleEmptyBlockComponent height={'16px'} />
					<div className="articleSection__content_block_description">
						<span>To ensure fairness and minimize abuse, Optimism employed the following filtering mechanisms:</span>
						<NumberedComponent
							boldPrefix={false}
							isGrayList
							list={[
								'Exclusion of Sybil addresses, including those suspected of multi-account manipulation;',
								'Filtering out wallets associated with centralized exchanges or fiat on/off-ramps.',
							]}
							description='Point reduction for wallets that performed all qualifying transactions in a short time window;'
						/>
						<span>This airdrop marked a milestone for the crypto industry, clearly demonstrating that genuine user participation and long-term engagement are essential pillars in building and growing decentralized blockchain ecosystems.</span>
					</div>
				</div>

				<ArticleEmptyBlockComponent height={'32px'} />
				<div className="articleSection__content_block _5">
					<h2>Arkham:</h2>
					<ArticleEmptyBlockComponent height={'16px'} />
					<div className="articleSection__content_block_description">
						<span>In the summer of 2023, the Arkham Intelligence platform unexpectedly distributed ARKM tokens to users who had previously registered and used the platform to analyze and monitor cryptocurrency wallets and transactions.</span>
					</div>
					<ArticleEmptyBlockComponent height={'24px'} />
					<div className="articleSection__content_block _5">
						<p>Eligibility criteria and retrodrop overview:</p>
						<ArticleEmptyBlockComponent height={'16px'} />
						<div className="articleSection__content_block_description">
							<span>Participants earned points through various actions on the platform, including:</span>
							<NumberedComponent
								boldPrefix={false}
								isGrayList
								list={[
									'Trading on Arkham Exchange: users received points for every $10 in trading volume;',
									'Referral Program: 15 points were awarded for each friend referred who registered and started trading;',
									'Task Completion: points were also earned by completing tasks such as making deposits or engaging with specific platform features.'
								]}
							/>
							<span>Accumulated points could be redeemed for $ARKM tokens at the end of the airdrop season.</span>
							<span>The number of $ARKM tokens received depended on how many points a user accumulated. On average, users received approximately $285 worth of $ARKM tokens. Some highly active participants received over 10 000 tokens, and one particular wallet received 249 353 $ARKM, worth over $180 000 at the time of distribution.</span>
							{/* <p>Sybil filtering and abuse prevention:</p>
							<span>To ensure a fair airdrop and prevent abuse, Arkham implemented the following measures:</span>
							<NumberedComponent
								boldPrefix={false}
								isGrayList
								list={[
									'Sybil Account Filtering: Wallets suspected of using multiple accounts to farm extra rewards were excluded from the distribution;',
									'Activity Verification: Only genuine platform activity was counted - such as actual trading and valid participation in the referral program.',
								]}
							/>
							<span>This airdrop serves as a reminder that sometimes simply registering and showing curiosity about a project and its tools can lead to a meaningful reward - even without expecting anything in return.</span> */}
						</div>
					</div>
					<ArticleEmptyBlockComponent height={'24px'} />
					<div className="articleSection__content_block _7">
						<p>Sybil filtering and abuse prevention:</p>
						<ArticleEmptyBlockComponent height={'16px'} />
						<div className="articleSection__content_block_description">
							<NumberedComponent
								boldPrefix={false}
								isGrayList
								list={[
									'Sybil Account Filtering: Wallets suspected of using multiple accounts to farm extra rewards were excluded from the distribution;',
									'Activity Verification: Only genuine platform activity was counted - such as actual trading and valid participation in the referral program.',
								]}
								description='To ensure a fair airdrop and prevent abuse, Arkham implemented the following measures:'
							/>
							<span>This airdrop serves as a reminder that sometimes simply registering and showing curiosity about a project and its tools can lead to a meaningful reward - even without expecting anything in return.</span>
						</div>
					</div>
				</div>
				<ArticleEmptyBlockComponent height={'32px'} />
				<div className="articleSection__content_block _5">
					<h2>Hyperliquid:</h2>
					<ArticleEmptyBlockComponent height={'16px'} />
					<div className="articleSection__content_block_description">
						<span>In the fall of 2024, the decentralized exchange Hyperliquid executed one of the largest retroactive airdrops in crypto history. What made this airdrop stand out was the complete absence of allocations to venture capital (VC) investors, making it unique compared to most other initiatives in the space.</span>
					</div>
				</div>
				<ArticleEmptyBlockComponent height={'24px'} />
				<div className="articleSection__content_block _7">
					<p>Eligibility criteria and retrodrop overview:</p>
					<ArticleEmptyBlockComponent height={'16px'} />
					<div className="articleSection__content_block_description">
						<span>To qualify for the retroairdrop, users had to accumulate points based on their activity on the platform over a 12-month period leading up to November 11, 2024.The primary ways to earn points included:</span>
						<NumberedComponent
							boldPrefix={false}
							isGrayList
							list={[
								'Trading on the platform: the higher the trading volume, the more points earned;',
								'Staking $USDC in Vaults: participation in network security and liquidity provisioning, with corresponding rewards;',
								'Referral program participation: bringing new users to the platform also earned additional points.'
							]}
						/>
						<span>It’s important to highlight that Hyperliquid did not involve venture capital investors, allowing them to allocate 76,2% of the total token supply toward rewarding the community.</span>
						<span>The amount of $HYPE tokens a user received was directly based on their accumulated points. On average, users were rewarded with approximately 2 882 $HYPE tokens, which at the time of the airdrop was worth around $45 000. Some of the most active participants received significantly more, depending on their contribution to the platform’s growth. In total, 94 000 users were included in the airdrop.</span>
					</div>
				</div>
				<ArticleEmptyBlockComponent height={'24px'} />
				<div className="articleSection__content_block _7">
					<p>Sybil filtering and abuse prevention:</p>
					<ArticleEmptyBlockComponent height={'16px'} />
					<div className="articleSection__content_block_description">
						<span>To maintain fairness and integrity in the distribution process, Hyperliquid implemented a strict set of anti-abuse measures:</span>
						<NumberedComponent
							boldPrefix={false}
							isGrayList
							list={[
								'Exclusion of Sybil accounts: Wallets suspected of being part of multi-account farming strategies were removed from eligibility;',
								'Activity verification: Only real, organic user actions were considered - such as legitimate trading and genuine referral activity. The team also excluded wash traders;',
								'Terms agreement requirement: Users were required to accept the terms of participation by a set deadline in order to claim their tokens.'
							]}
						/>
						<span>Hyperliquid’s airdrop set a new standard in how retroactive rewards can be distributed - showing that generous and fair token distributions are possible without VC involvement. The drop greatly boosted community trust and drew increased attention to Hyperliquid as one of the most promising DeFi platforms in the ecosystem.</span>
					</div>
				</div>
				<ArticleEmptyBlockComponent height={'32px'} />
				<div className="articleSection__content_block _5">
					<h2>Starknet:</h2>
					<ArticleEmptyBlockComponent height={'16px'} />
					<div className="articleSection__content_block_description">
						<span>In the winter of 2024, Starknet - a Layer 2 blockchain built on top of Ethereum - launched its Provisions Program, a large-scale retrodrop distributing its native token, STRK.</span>
					</div>
					<ArticleEmptyBlockComponent height={'24px'} />
					<div className="articleSection__content_block _7">
						<p>Eligibility criteria and retrodrop overview:</p>
						<ArticleEmptyBlockComponent height={'16px'} />
						<div className="articleSection__content_block_description">
							<span>Participants were divided into several categories, each with its own specific requirements:</span>
							<span style={{ fontWeight: '700', color: '#ABAAB7', fontFamily: "Poppins-Bold" }}>1. Starknet Users:</span>
							<NumberedComponent
								boldPrefix={false}
								isGrayList
								list={[
									'Conducted more than 5 transactions before November 15, 2023;',
									'Were active for at least 3 months;',
									'Had a total transaction volume of at least $100;',
									'Held at least 0.005 ETH in their wallet at the time of the snapshot;',
									'Reward size: ranged from 500 to 10 000 $STRK, with bonus tokens possible for additional activity.'
								]}

							/>
							<span style={{ fontWeight: '700', color: '#ABAAB7', fontFamily: "Poppins-Bold" }}>2. StarkEx Users:</span>
							<NumberedComponent
								boldPrefix={false}
								isGrayList

								list={[
									'Performed at least 8 transactions in StarkEx-based dApps (such as dYdX, Rhino.fi, ImmutableX, Sorare) before June 1, 2022;',
									'Reward size: a fixed amount of 111,1 $STRK.',
								]}

							/>
							<span style={{ fontWeight: '700', color: '#ABAAB7', fontFamily: "Poppins-Bold" }}>3. Starknet Community Contributors:</span>
							<NumberedComponent
								boldPrefix={false}
								isGrayList
								list={[
									'Included early contributors from programs like ECMP, event organizers, and other active community members;',
									'Reward size: from 10 000 to 180 000 $STRK.',
								]}

							/>
							<span style={{ fontWeight: '700', color: '#ABAAB7', fontFamily: "Poppins-Bold" }}>4. Starknet Developers:</span>

							<NumberedComponent
								boldPrefix={false}
								isGrayList
								list={[
									'Made at least 3 commits to repositories officially recognized as part of the Starknet ecosystem before November 15, 2023;',
									'Reward size: 10 000 $STRK.',
								]}

							/>
							<span style={{ fontWeight: '700', color: '#ABAAB7', fontFamily: "Poppins-Bold" }}>5. Ethereum Community Members:</span>

							<NumberedComponent
								boldPrefix={false}
								isGrayList
								list={[
									'Solo stakers: Who deposited ETH before the Ethereum Merge in September 2022; got 1 800 $STRK per validator.',
									'Ethereum developers: Who made 3+ commits to Ethereum ecosystem repositories before November 15, 202; got 1 800 $STRK.',
									'EIP authors: Who published an Ethereum Improvement Proposal before November 15, 2023; got 2 000 $STRK.'
								]}

							/>
							<span>In total, over 700 million STRK tokens were distributed across 1,3 million users as part of the Provisions Program.</span>
							<span>Many recipients received significant rewards for simply using the network, with token values ranging from approximately $1 350 to $27 000. This amounts that were not fixed, but instead depended entirely on the user's individual level of activity and contribution.</span>
							<span>This retrodrop became not only the largest in terms of total recipients, but also the first to include both Starknet users and contributors from Ethereum’s mainnet - marking a major milestone in cross-ecosystem community recognition.</span>
						</div>
					</div>
					<div className="articleSection__content_block _5">
						<ArticleEmptyBlockComponent height={'24px'} />
						<p>Conclusion:</p>
						<ArticleEmptyBlockComponent height={'16px'} />
						<div className="articleSection__content_block_description">
							<span>These five stories prove that retrodrops are not just a marketing gimmick - they are a genuine way for projects to reward their users and generate excitement around their ecosystems. Who knows - the next successful retrodrop might be just around the corner, and you could be one of its lucky recipients!</span>
							<span>That’s why it’s always worth staying active, curious, and engaged with emerging crypto projects.</span>
							<span>And for the most patient, ambitious, and inquisitive readers who made it to this point - you’ll receive a special bonus: detailed guides on how to position yourself for future retrodrops that might one day become just as legendary as the five we explored above. We’ve included everything you need to get started below.</span>
						</div>
					</div>
				</div>
				<ArticleEmptyBlockComponent height={'48px'} />
				<div className="articleSection__content_block _5">
					<h1>How to become part of a retrodrop without even knowing it</h1>
					<ArticleEmptyBlockComponent height={'16px'} />
					<div className="articleSection__content_block_description">
						<span>You’re casually using a new decentralized application, making a few transactions, maybe testing out a platform just out of curiosity… And then, a few months later, you find out you’ve been rewarded with tokens - sometimes worth hundreds or even thousands of dollars.</span>
						<span>That’s the magic of retrodrops - and the most fascinating part? You may already be participating in one without even realizing it.</span>
					</div>
				</div>
				<ArticleEmptyBlockComponent height={'32px'} />
				<div className="articleSection__content_block _5">
					<h2>What is “Unintentional Participation”?</h2>
					<ArticleEmptyBlockComponent height={'16px'} />
					<div className="articleSection__content_block_description">
						<span>Unlike traditional airdrops, retrodrops don’t require pre-registration. You don’t need to fill out forms or wait for confirmations. All that’s needed is real activity on a platform - whether that’s trading, testing features, voting in a DAO, or simply using a wallet within the right ecosystem.</span>
						<span>Put simply - if you’re interacting with new crypto projects early on, you might already be eligible for a future retrodrop.</span>
					</div>
				</div>
				<ArticleEmptyBlockComponent height={'32px'} />
				<div className="articleSection__content_block _5">
					<h2>What should you do to increase your chances to get retrodrop?</h2>
					<ArticleEmptyBlockComponent height={'16px'} />
					<div className="articleSection__content_block_description">
						<span>Here are some universal strategies that can help you become eligible for future airdrops - even if no official announcement has been made:</span>
						<NumberedComponent
							boldPrefix={false}
							isGrayList
							isList
							list={[
								'1. Explore early-stage projects: Use DeFi protocols, NFT marketplaces, bridges, and wallets in lesser-known or newly launched networks;',
								'2. Be active in ecosystems like Ethereum, Solana, and Cosmos: Networks such as Starknet, Arbitrum, zkSync, Base, Jupiter, Pengu, Celestia, and others often reward users for basic activity like swaps, staking, and dApp interactions;',
								'3. Use cross-chain bridges and interoperability tools: Many projects reward users for engaging in cross-chain activity and bridging tokens between networks;',
								'4. Participate in DAOs and governance votes: Even minimal contributions - like casting a single vote - may be noticed and rewarded (as seen with the Optimism drop);',
								'5. Support open-source development and test products: Engage with early-stage projects, submit bug reports, participate in alpha/beta testing — these actions often count as meaningful contributions;',
								'6. Research project investments: Do your own research into recent funding rounds. If Tier 1 investors are showing interest in a project, it might be worth interacting with early.'
							]}
						/>
					</div>
				</div>
				<ArticleEmptyBlockComponent height={'32px'} />
				<div className="articleSection__content_block _5">
					<h2>Why do projects give out retrodrops?</h2>
					<ArticleEmptyBlockComponent height={'16px'} />
					<div className="articleSection__content_block_description">
						<span>Because real users matter far more than those just chasing free tokens. Projects want to reward those who genuinely help grow the ecosystem, test features, and provide feedback That’s why most teams don’t announce retrodrops in advance - to avoid attracting a flood of «Sybil» accounts and turning the process into a reward-hunting race.</span>
					</div>
				</div>
				<ArticleEmptyBlockComponent height={'32px'} />
				<div className="articleSection__content_block _5">
					<h2>A few tips to avoid disqualification</h2>
					<ArticleEmptyBlockComponent height={'16px'} />
					<div className="articleSection__content_block_description">
						<NumberedComponent
							boldPrefix={false}
							isGrayList
							list={[
								'Don’t only use one platform - diversify your on-chain activity across different dApps and protocols. Make your behavior look organic and varied;',
								'Avoid creating dozens of fake accounts - Sybil activity is easily traceable. If you’re using multiple accounts, do it properly with proxy setups and anti-detect browsers;',
								'Use projects with genuine interest and intention - those who approach Web3 sincerely are the ones most likely to be rewarded in the long run.',
							]}
						/>
					</div>
				</div>
				<ArticleEmptyBlockComponent height={'32px'} />
				<div className="articleSection__content_block _5">
					<h2>Conclusion:</h2>
					<ArticleEmptyBlockComponent height={'16px'} />
					<div className="articleSection__content_block_description">
						<span>You might not even realize it - but you could already be in line for a retrodrop. And that’s the beauty of it. The secret is to be an active participant in Web3, without expecting instant rewards. One day, that curiosity and involvement might pay off - in the form of a surprise token drop, delivered as a thank-you for believing in a project when no one else was watching.</span>
					</div>
				</div>
				<ArticleEmptyBlockComponent height={'48px'} />
				<div className="articleSection__content_block _5">
					<h1>How to tell if a project is preparing a retrodrop?</h1>
					<ArticleEmptyBlockComponent height={'16px'} />
					<div className="articleSection__content_block_description">
						<span>Retrodrops are usually not announced in advance - that’s part of their nature. However, if you look closely, many projects leave behind subtle “breadcrumbs” that hint: “Something might be coming…”If you learn how to recognize these signals, your chances of being among the rewarded users increase significantly.</span>
						<NumberedComponent
							boldPrefix={false}
							isGrayList
							index='1'
							title="The project doesn’t have a token (yet), but is actively growing"
							list={[
								'The project does not have its own token;',
								'Yet it is actively gaining users, building features, and expanding integrations;',
							]}
							description='If you notice that:'
							secondDescription='Then chances are, a token launch is on the roadmap. And when it does happen, it’s logical to reward early and loyal users, as projects like Arbitrum, Starknet, Hyperliquid, Arkham, and others have done.'
						/>
						<NumberedComponent
							boldPrefix={false}
							isGrayList
							index='2'
							title="The project has a points system or leaderboard"
							list={[
								'XP, Points, Karma, Score;',
								'Levels or Ranks;',
								'Seasonal formats (e.g. Season 1, Season 2, etc.).'
							]}
							description='If a project is assigning XP, karma, or placing users on leaderboards - it’s rarely just for fun. It’s usually a way to track user contributions and allocate a future retrodrop proportionally.
						    Examples of systems to look for:'
							secondDescription='Example projects: Hyperliquid, Manta, Layer3, zkSync Quests, Kamino, Blast.'
						/>
						<NumberedComponent
							boldPrefix={false}
							isGrayList
							index='3'
							title="The team subtly hints at a token"
							list={[
								'Planning for decentralization;',
								'There will be a “Community allocation”;',
								'Phrases like: “We will reward early users” or “Active users will be recognized”;'
							]}
							description='While most teams avoid direct promises, you’ll often catch subtle clues in Blog posts/Interviews/Discord, Telegram, or AMA sessions look for phrases like:'
							secondDescription='Pro tip: Monitor their Twitter (X), Discord announcements, and community chats closely.'
						/>
						<NumberedComponent
							boldPrefix={false}
							isGrayList
							index='4'
							title="The project is integrating with ecosystems that have airdrop history"
							list={[
								'Partners with ecosystems that previously rewarded users;',
								'Launches in networks with high-profile activity (Arbitrum, Optimism, Base, etc.);',
								'Is featured on task platforms like Layer3, Galxe, TaskOn - known for pre-drop engagement tracking…'
							]}
							description='Signs of future potential airdrops include when a project:'
							secondDescription='All these integrations may be early preparation for a future drop.'
						/>
						<span>Examples: Participation in L2E campaigns, DeFi integrations, NFT ecosystem partnerships.</span>
						<NumberedComponent
							boldPrefix={false}
							isGrayList
							index='5'
							title="The project is tracking user activity"
							list={[
								'Follow social media accounts;',
								'Connect a wallet to track actions;',
								'Verify your identity (e.g. via Gitcoin Passport);',
								'Interact with products as part of a campaign.'
							]}
							description='Be cautious when you see a project asking you to:'
							secondDescription='These are often pre-drop filtering mechanics meant to detect bots and reward real users.'
						/>
						<NumberedComponent
							boldPrefix={false}
							isGrayList
							index='6'
							title="Signs of anti-Sybil protection"
							list={[
								'Unique interactions (e.g. polls, limited-time tasks);',
								'Human verification steps;',
								'One-time actions with device/IP limits;',
								'Frequent changes to participation rules and requirements;'
							]}
							description='If the platform emphasizes:'
							secondDescription='These are usually indicators that the team is preparing for a fair distribution - and that a retrodrop is likely coming.'
						/>
					</div>
					<ArticleEmptyBlockComponent height={'48px'} />
					<div className="articleSection__content_block _5">
						<h1>The benefits of this direction in crypto</h1>
						<ArticleEmptyBlockComponent height={'16px'} />
						<div className="articleSection__content_block_description">
							<span>Getting involved with retrodrops offers numerous advantages, and some of the key ones are outlined below:</span>
							<NumberedComponent
								list={[
									'Minimal risks and low entry costs: In many cases, simply using platforms and services is enough - with no need for major financial investment. Yet the potential rewards can be surprisingly high;',
									'High profitability: Many users have already received thousands, tens of thousands, or even hundreds of thousands of dollars in retrodrops - just by actively engaging with promising projects at early stages;',
									'Automation: The retrodrop niche has evolved to the point where specialized software can now automate nearly all necessary interactions for you. With the right setup, you can earn without needing to manually do anything;',
									'Passive income: Retrodrops allow you to receive tokens and profits for actions you`ve done in the past, without requiring any extra effort later on.'
								]}
								secondDescription='In summary, retrodrops represent a simple, low-risk, and highly effective way to earn income in crypto - offering solid potential returns while requiring minimal financial and time investment.'
							/>
						</div>
					</div>
					<ArticleEmptyBlockComponent height={'48px'} />
					<div className="articleSection__content_block _5">
						<h1>Risks</h1>
						<ArticleEmptyBlockComponent height={'16px'} />
						<div className="articleSection__content_block_description">
							<span>Although retrodrops are considered one of the most promising earning opportunities in the crypto space, they also come with significant risks.</span>
							<span>The main uncertainty for participants is the lack of guarantees when it comes to receiving rewards. Since these airdrops are based on users' past activity, it is nearly impossible to know in advance whether a token will launch or what the eligibility criteria will be. As a result, there's always a risk of losing your investment - whether because the project cancels its planned airdrop, or because you end up excluded from the list of eligible recipients.</span>
							<span>For users who rely on multi-accounting (commonly known as "farmers" or Sybil actors), the risk increases substantially. Each additional wallet requires separate financial input for network fees and interactions. There are also added costs for technical tools like anti-detect browsers, VPNs, and other resources used to maintain anonymity and scale operations.</span>
							<span>Modern point-based reward systems aim to mitigate some of these risks, by giving participants a clearer idea of what actions might be rewarded. However, even these systems do not provide certainty regarding the size of the reward or the exact timing of the token distribution.</span>
							<span>That’s why it’s essential to approach retrodrop participation rationally - only investing time and money you’re prepared to lose, and avoiding any dependency on these rewards for your financial well-being.</span>
						</div>
					</div>
					<ArticleEmptyBlockComponent height={'48px'} />
					<div className="articleSection__content_block _5">
						<h1>Where to Start?</h1>
						<ArticleEmptyBlockComponent height={'16px'} />
						<div className="articleSection__content_block_description">
							<span>We’ve prepared a selection of interesting and promising projects that you can begin engaging with right now - giving you the potential to earn future rewards through retroactive airdrops. Let’s take a look at this list:</span>
							<p>OpenSea:</p>
							<NumberedComponent
								boldPrefix={false}
								isGrayList
								list={[
									<>
										This is the leading NFT marketplace. They’ve introduced a loyalty system based on earning XP through user activity. All the detailed steps and actions you need to take are described in the guide. You can check it out and understand where to begin - {' '}
										(<a
											href="https://app.nfd.gg/ru/reviews/retrodrops/67e6f61ba7aa0488cef0165f"
											target="_blank"
											rel="noopener noreferrer"
										>
											GUIDE
										</a>
										).
									</>
								]}

							/>
							<p>Backpack:</p>
							<NumberedComponent
								boldPrefix={false}
								isGrayList
								list={[
									<>
										This is the first centralized exchange built on the Solana network. To participate, you’ll need to use the exchange regularly. Each week, you’ll earn XP, which is expected to be converted into the project’s native token in the future. You can explore how to get started - {' '}
										(<a
											href="https://app.nfd.gg/ru/reviews/retrodrops/65f2e269ff14c0db172dd13f"
											target="_blank"
											rel="noopener noreferrer"
										>
											GUIDE
										</a>
										).
									</>
								]}
							/>
							<p>Paradex:</p>
							<NumberedComponent
								boldPrefix={false}
								isGrayList
								list={[
									<>
										A high-performance Layer 2-based project that gives you all the benefits of decentralization for perpetual contract trading. You need to stay active weekly, complete tasks, and earn XP - which is expected to be rewarded with the project’s token in the future. Learn how to begin - {' '}
										(<a
											href="https://app.nfd.gg/ru/reviews/retrodrops/67ac6cfc6630415be2bdc163"
											target="_blank"
											rel="noopener noreferrer"
										>
											GUIDE
										</a>
										).
									</>
								]}
							/>
						</div>
					</div>
					<ArticleEmptyBlockComponent height={'48px'} />
					<div className="articleSection__content_block _5">
						<h1>Conclusion</h1>
						<ArticleEmptyBlockComponent height={'16px'} />
						<div className="articleSection__content_block_description">
							<span>Retrodrops in the crypto space represent a highly promising way to earn - especially for newcomers exploring digital assets with a limited budget, but also for those with capital who can scale their efforts. On one hand, these distributions are beneficial for startups and blockchain services, as they help quickly attract attention and build a base of loyal users. On the other hand, users gain an opportunity to grow their wallets without making large financial commitments.</span>
							<span>Since the emergence of retrodrops, the crypto community has witnessed many participants receive substantial payouts. However, with the growing number of users and the spread of tactics to bypass restrictions, projects are now becoming more selective - rewarding those who are genuinely active and deeply involved.</span>
							<span> Of course, there are no guarantees of success: there's always a chance that a user won’t meet the criteria or that the project might cancel its distribution altogether. But despite these uncertainties, the appeal of receiving free crypto remains strong - and for many beginners, such airdrops serve as an effective entry point and starter capital for further exploration of the crypto ecosystem.</span>
						</div>
					</div>
				</div>
			</div>
		</div >
	);
};

export default ArticleSection;